import { Stack } from '@mui/material';
import { ImportResults } from 'src/components/ImportPortalioProjectModal/import-results';
import {
  IMPORT_MORE,
  usePortalioImport,
} from 'src/components/ImportPortalioProjectModal/portalio-import-context';
import { ModalStep, useModalStep } from 'src/components/ModalContainer';

interface ImportCompletedStepProps {
  projectIds: number[];
}

/** Step 3: what the import created and updated, per project. */
export const ImportCompletedStep = ({ projectIds }: ImportCompletedStepProps) => {
  const { popStep } = useModalStep();
  const { records, errors, close } = usePortalioImport();

  return (
    <ModalStep
      title="Import complete"
      actions={[
        { label: 'Import more', kind: 'secondary', onClick: () => popStep(IMPORT_MORE) },
        {
          label: 'Done',
          kind: 'primary',
          onClick: close,
          testId: 'import-portalio-projects-results-done',
        },
      ]}
    >
      <Stack data-testid="import-portalio-projects-results">
        <ImportResults
          records={records}
          loading={false}
          projectIds={projectIds}
          errors={errors}
        />
      </Stack>
    </ModalStep>
  );
};
